<div class="wrapper has-padding success-wrap">
  <h1 class="bofa--heading is-4">Success: Your profile was created</h1>

  <div class="bofa--alert has-background cool-gray-5 has-padding is-stacked">
    <span>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="img-size" aria-label="information icon">
          <g data-name="ICON OUTLINES">
          <path fill="#012169" d="M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,19a9,9,0,1,1,9-9A9.01,9.01,0,0,1,12,21Z" transform="translate(-2 -2)"/>
          <path fill="#012169" d="M11.992,6.848a.632.632,0,0,0-.617.64.625.625,0,0,0,1.25,0A.635.635,0,0,0,11.992,6.848Z" transform="translate(-2 -2)"/>
          <rect fill="#012169" x="9.5" y="7" width="1" height="8"/></g>
      </svg>
    </span>
    <span>If you have trouble accessing your application, please</span><br />
    <span>reach out to the contact listed in your invitation email.</span>
  </div>

  <div class="bofa--action_bar is-taller">
    <button (click)="navigateLogin()" class="bofa--button primary large">Login</button>
  </div>

</div>